import axios from 'axios';
import Vue from 'vue';
import VueAWN from "vue-awesome-notifications"

// This is to be able to use notifications system
Vue.use(VueAWN);
const myVue = new Vue();

const state = {
    rooms: []
}
const getters = {
    getRooms(state) {
        return state.rooms;
    },
    getRoomByName: (state) => (name) => {
        return state.rooms.find(r => r.name == name);
    }
}
const mutations = {
    setRooms(state, rooms) {
        state.rooms = rooms.slice(0);
    },
    updateRoom(state, room){
        for(let r of state.rooms)
            if(r.name == room.name)
                r.favorite = room.favorite;
    }
}
const actions = {
    searchRooms({}, payload) {
        // payload.in   <-- dateIn
        // payload.out  <-- dateOut
        // return axios.get("https://jsonplaceholder.typicode.com/todos/5")
        return axios.get(`https://yzrs9bb18l.execute-api.eu-central-1.amazonaws.com/dev/booking?dateIn=${payload.in}&dateOut=${payload.out}`)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                console.log(err);
                myVue.$awn.alert(err.message);
            });
    },
    setRooms({ commit }, rooms) {
        commit("setRooms", rooms);
    },
    updateRoom({ commit }, room){
        commit("updateRoom", room);
    },
    storeBooking({ commit }, book){
        return axios.post('https://yzrs9bb18l.execute-api.eu-central-1.amazonaws.com/dev/booking', book)
            .then(res => {
                return res;
            })
            .catch(err => {
                console.log(err);
                myVue.$awn.alert(err.message);
            });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}